module.exports = __webpack_public_path__ + "media/images/icon_list/offending_comment-bf944f4aface9dfdeef8c5e29cd3b970.svg";